module.exports = __webpack_public_path__ + "img/assist.36d066ad.png";